import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-workplace-permission-dashboard',
  templateUrl: './workplace-permission-dashboard.component.html',
  styleUrls: ['./workplace-permission-dashboard.component.scss']
})
export class WorkplacePermissionDashboardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
